import { DEPRECATED_REACT_PROPS, Popper, PopperProps, TextField } from '@chronosphereio/chrono-ui';
import { Autocomplete } from '@mui/material';
import { RefObject, useState } from 'react';

interface OverrideSeriesAutocompleteInputProps {
  value: string;
  onChange: (value: string) => void;
  seriesNames: string[];
  inputRef?: RefObject<HTMLInputElement>;
}

export function OverrideSeriesAutocomplete({
  value,
  onChange,
  seriesNames,
  inputRef,
}: OverrideSeriesAutocompleteInputProps) {
  // Allow freeform input in addition to autocomplete with series name suggestions.
  // More flexible in case the name isn't in query results for active time range or selected variables.
  const [inputValue, setInputValue] = useState('');

  return (
    <Autocomplete
      ListboxProps={{ style: { maxHeight: 200 } }}
      freeSolo
      PopperComponent={PopperFitContent}
      forcePopupIcon={false}
      disableClearable
      options={seriesNames}
      value={value}
      onChange={(_, newValue) => onChange(newValue)}
      onBlur={() => onChange(inputValue)}
      inputValue={inputValue}
      onInputChange={(_, newValue) => setInputValue(newValue)}
      renderInput={(params) => <TextField {...params} label="Series name" inputRef={inputRef} />}
    />
  );
}

/**
 * Popper that appears below series name text input
 */
function PopperFitContent(props: PopperProps) {
  return <Popper {...props} style={{ width: 'fit-content' }} placement="bottom-start" {...DEPRECATED_REACT_PROPS} />;
}
